// Launches the welcome tour once, after a platform invitation is accepted.
//
// WelcomePage.js records the request through ./welcomeTourFlag (a plain
// sessionStorage handoff — see that module's header for why the boundary
// cannot be crossed by an import) and navigates to "/". This component,
// mounted inside TourProvider in src/App.js beside AppNudge, consumes the
// request on its first mount and launches tourRegistry[WELCOME_TOUR_ID].
//
// Modeled on AppNudge in src/App.js: it renders inside the TourProvider tree
// so useTour() is available, and renders nothing itself. All of the one-shot
// logic lives in welcomeTourFlag.js, which is where it is tested — this file
// is deliberately only the wiring between that decision and useTour().

import React from 'react';
import { useTour } from './TourContext';
import { WELCOME_TOUR_ID, consumeWelcomeTourRequest } from './welcomeTourFlag';

export default function WelcomeTourLauncher() {
    const { launchTour } = useTour();

    React.useEffect(() => {
        // consumeWelcomeTourRequest clears the request before returning true,
        // so a remount never relaunches.
        if (consumeWelcomeTourRequest()) launchTour(WELCOME_TOUR_ID);
        // Runs once per mount, by design — this is a one-shot request read, not
        // a reactive effect keyed on launchTour identity.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}
